export * from './iconFontAwesomeEducationMusic';
export * from './iconFontAwesomeEducationBell';
export * from './iconFontAwesomeEducationSchool';
export * from './iconFontAwesomeEducationAward';
export * from './iconFontAwesomeEducationChalkboard';
export * from './iconFontAwesomeEducationUserGraduate';
export * from './iconFontAwesomeEducationShapes';
export * from './iconFontAwesomeEducationSchoolLock';
export * from './iconFontAwesomeEducationSchoolFlag';
export * from './iconFontAwesomeEducationSchoolCircleXmark';
export * from './iconFontAwesomeEducationSchoolCircleExclamation';
export * from './iconFontAwesomeEducationSchoolCircleCheck';
export * from './iconFontAwesomeEducationPersonChalkboard';
export * from './iconFontAwesomeEducationMicroscope';
export * from './iconFontAwesomeEducationMasksTheater';
export * from './iconFontAwesomeEducationLaptopFile';
export * from './iconFontAwesomeEducationLaptopCode';
export * from './iconFontAwesomeEducationGraduationCap';
export * from './iconFontAwesomeEducationChalkboardUser';
export * from './iconFontAwesomeEducationBookOpenReader';
export * from './iconFontAwesomeEducationBookOpen';
export * from './iconFontAwesomeEducationBellSlash';
export * from './iconFontAwesomeEducationAtom';
export * from './iconFontAwesomeEducationAppleWhole';
